import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-connect-scan',
  templateUrl: './wallet-connect-scan.component.html',
  styleUrls: ['./wallet-connect-scan.component.scss']
})
export class WalletConnectScanComponent {

}
